/* Linsoul discover by (sections/ls-discover.liquid): switches between the group stages. Each stage runs on its own
 * (assets/ls-sound-uses.js: tabs, autoplay, ripple); a hidden stage is display:none, so its timer and ripple stay idle
 * until it is shown. GSAP slides the switcher pill and crossfades the stages; no motion under reduced motion. */
(() => {
  const reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const loadGsap = (src) => {
    if (window.gsap) return Promise.resolve(window.gsap);
    if (window.lsLoadGsap) return window.lsLoadGsap(src);
    return new Promise((resolve, reject) => {
      const tag = document.createElement('script');
      tag.src = src;
      tag.async = true;
      tag.onload = () => (window.gsap ? resolve(window.gsap) : reject(new Error('gsap')));
      tag.onerror = reject;
      document.head.appendChild(tag);
    });
  };

  function init(root) {
    if (root.dataset.lsdReady) return;
    root.dataset.lsdReady = '1';
    const seg = root.querySelector('[data-lsd-seg]');
    if (!seg) return;
    const btns = [...seg.querySelectorAll('[role=tab]')];
    const stages = btns.map((b) => document.getElementById(b.getAttribute('aria-controls')));
    if (stages.some((s) => !s)) return;
    const pill = seg.querySelector('.lsd__seg-pill');
    const reduced = reduceQuery.matches;
    let gsap = null;
    let index = Math.max(0, btns.findIndex((b) => b.getAttribute('aria-selected') === 'true'));
    let swap = null;

    const placePill = (instant) => {
      if (!pill) return;
      const b = btns[index];
      const to = { x: b.offsetLeft, width: b.offsetWidth };
      if (gsap && !instant && !reduced) gsap.to(pill, { ...to, duration: 0.42, ease: 'power3.out', overwrite: true });
      else if (gsap) gsap.set(pill, to);
      else { pill.style.transform = `translateX(${to.x}px)`; pill.style.width = `${to.width}px`; }
      seg.classList.add('has-pill');
    };

    const select = (next, focus) => {
      if (next === index) return;
      const prev = stages[index];
      const target = stages[next];
      index = next;
      btns.forEach((b, i) => {
        const on = i === next;
        b.setAttribute('aria-selected', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      if (focus) btns[next].focus();
      placePill(false);
      if (swap) swap.progress(1).kill();
      if (!gsap || reduced) {
        prev.hidden = true;
        target.hidden = false;
        return;
      }
      const panel = target.querySelector('.lsu-panel:not([data-off])');
      const items = panel ? panel.querySelectorAll('[data-lsu-in]') : [];
      swap = gsap.timeline({ onComplete: () => { swap = null; } })
        .to(prev, { autoAlpha: 0, y: 10, duration: 0.22, ease: 'power2.in' })
        .add(() => {
          prev.hidden = true;
          gsap.set(prev, { clearProps: 'opacity,visibility,transform' });
          target.hidden = false;
          gsap.set(items, { autoAlpha: 0, y: 22 });
        })
        .fromTo(target, { autoAlpha: 0, y: 16 }, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power3.out', clearProps: 'opacity,visibility,transform' })
        .to(items, { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out', stagger: 0.06, clearProps: 'opacity,visibility,transform' }, '<0.12');
    };

    btns.forEach((b, i) => {
      b.addEventListener('click', () => select(i, false));
      b.addEventListener('keydown', (e) => {
        let n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % btns.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + btns.length) % btns.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = btns.length - 1;
        if (n === null) return;
        e.preventDefault();
        select(n, true);
      });
    });

    placePill(true);
    new ResizeObserver(() => placePill(true)).observe(seg);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => placePill(true));

    const near = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      near.disconnect();
      loadGsap(root.dataset.gsapSrc).then((g) => { gsap = g; placePill(true); }).catch(() => {});
    }, { rootMargin: '600px 0px' });
    near.observe(root);

    if (root.hasAttribute('data-design-mode')) {
      document.addEventListener('shopify:block:select', (e) => {
        const i = stages.findIndex((s) => s.contains(e.target));
        if (i > -1) select(i, false);
      });
    }
  }

  const run = () => document.querySelectorAll('[data-lsd]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
